module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/portfolio-sidebar-fluid-3e8fa99b3e0d260e7232b41ed9550578.jpg";